var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel10Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.539 39.2695H415.467L400.072 269.065H385.053L374.539 39.2695Z",
    fill: "url(#paint0_linear_7088_4236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.539 484.596H415.467L400.072 254.8H385.053L374.539 484.596Z",
    fill: "url(#paint1_linear_7088_4236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M683.002 241.477L683.002 282.404L387.87 267.009L387.87 251.99L683.002 241.477Z",
    fill: "url(#paint2_linear_7088_4236)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.001 241.477L104.001 282.404L402.137 267.009L402.137 251.99L104.001 241.477Z",
    fill: "url(#paint3_linear_7088_4236)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555.974 502.412L520.529 522.876L386.295 259.589L399.302 252.079L555.974 502.412Z",
    fill: "url(#paint4_linear_7088_4236)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.124 0.992189L214.679 21.456L377.08 271.95L390.087 264.44L250.124 0.992189Z",
    fill: "url(#paint5_linear_7088_4236)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M654.448 388.959L633.984 424.403L386.09 263.506L393.599 250.499L654.448 388.959Z",
    fill: "url(#paint6_linear_7088_4236)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.668 99.4746L116.204 134.919L382.095 270.654L389.605 257.647L136.668 99.4746Z",
    fill: "url(#paint7_linear_7088_4236)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.473 522.879L231.028 502.415L391.927 254.522L404.934 262.032L266.473 522.879Z",
    fill: "url(#paint8_linear_7088_4236)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M571.443 21.4531L535.999 0.989276L400.263 266.878L413.27 274.388L571.443 21.4531Z",
    fill: "url(#paint9_linear_7088_4236)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.019 424.402L132.555 388.958L395.844 254.725L403.354 267.732L153.019 424.402Z",
    fill: "url(#paint10_linear_7088_4236)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M669.916 134.92L649.452 99.4755L398.956 261.875L406.466 274.882L669.916 134.92Z",
    fill: "url(#paint11_linear_7088_4236)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M734.223 411.488C734.223 434.475 581.95 453.11 394.111 453.11C206.272 453.11 53.999 434.475 53.999 411.488C53.999 388.501 206.272 369.866 394.111 369.866C581.95 369.866 734.223 388.501 734.223 411.488Z",
    fill: "url(#paint12_radial_7088_4236)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M638.352 411.49C638.352 416.087 540.386 419.814 419.539 419.814C298.692 419.814 200.726 416.087 200.726 411.49C200.726 406.892 298.692 403.165 419.539 403.165C540.386 403.165 638.352 406.892 638.352 411.49Z",
    fill: "url(#paint13_radial_7088_4236)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M245.474 279.74C245.09 277.171 247.277 274.95 249.852 275.296L399.206 295.313C401.273 295.59 402.756 297.443 402.575 299.521L399.422 335.56C399.227 337.783 397.213 339.39 395.003 339.086L254.293 319.761C252.576 319.525 251.221 318.185 250.964 316.472L245.474 279.74Z",
    fill: "#FF7B01"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.942 247.707C215.558 245.138 217.745 242.917 220.32 243.262L369.674 263.28C371.741 263.557 373.224 265.41 373.043 267.488L369.89 303.527C369.695 305.749 367.681 307.357 365.471 307.053L224.761 287.728C223.044 287.492 221.688 286.152 221.432 284.438L215.942 247.707Z",
    fill: "#FFA001"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.211 206.545C186.827 203.975 189.014 201.755 191.589 202.1L340.943 222.117C343.01 222.394 344.494 224.248 344.312 226.325L341.159 262.365C340.964 264.587 338.95 266.194 336.74 265.891L196.03 246.565C194.313 246.329 192.958 244.99 192.702 243.276L187.211 206.545Z",
    fill: "#FECC50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M542.167 279.74C542.551 277.171 540.364 274.95 537.789 275.296L388.436 295.313C386.369 295.59 384.885 297.443 385.067 299.521L388.22 335.56C388.414 337.783 390.428 339.39 392.638 339.086L533.348 319.761C535.065 319.525 536.421 318.185 536.677 316.472L542.167 279.74Z",
    fill: "#FF7B01"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M571.698 247.707C572.082 245.138 569.895 242.917 567.32 243.262L417.966 263.28C415.899 263.557 414.415 265.41 414.597 267.488L417.75 303.527C417.945 305.749 419.959 307.357 422.169 307.053L562.879 287.728C564.596 287.492 565.951 286.152 566.208 284.438L571.698 247.707Z",
    fill: "#FFA001"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M600.429 206.545C600.813 203.975 598.626 201.755 596.051 202.1L446.698 222.117C444.631 222.394 443.147 224.248 443.329 226.325L446.482 262.365C446.676 264.587 448.69 266.194 450.9 265.891L591.61 246.565C593.327 246.329 594.683 244.99 594.939 243.276L600.429 206.545Z",
    fill: "#FECC50"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M392.438 163.669C393.962 162.145 396.433 162.145 397.957 163.669L448.067 213.78C449.591 215.304 449.591 217.775 448.067 219.299L397.957 269.409C396.433 270.933 393.962 270.933 392.438 269.409L342.327 219.299C340.803 217.775 340.803 215.304 342.327 213.78L392.438 163.669Z",
    fill: "#C4C4C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M395.197 272.169V160.91L339.567 216.539L395.197 272.169Z",
    fill: "#FFD0F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M395.197 160.91V272.169L450.826 216.539L395.197 160.91Z",
    fill: "#FF97F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M506.455 272.169L450.826 216.539L395.197 272.169H506.455Z",
    fill: "#FFD0F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M506.455 272.169H395.197L450.826 327.798L506.455 272.169Z",
    fill: "#FF97F1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M395.197 272.169V383.427L450.826 327.798L395.197 272.169Z",
    fill: "#FF97F1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M395.197 383.427V272.169L339.567 327.798L395.197 383.427Z",
    fill: "#FFD0F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M395.197 272.169H283.938L339.567 327.798L395.197 272.169Z",
    fill: "#FF97F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M283.938 272.169H395.197L339.567 216.539L283.938 272.169Z",
    fill: "#FFD0F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M503.799 269.306C505.323 270.83 505.323 273.301 503.799 274.825L453.689 324.935C452.165 326.459 449.694 326.459 448.17 324.935L398.059 274.825C396.535 273.301 396.535 270.83 398.059 269.306L448.17 219.195C449.694 217.671 452.165 217.671 453.689 219.195L503.799 269.306Z",
    fill: "#C4C4C4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.065H506.558L450.929 216.436L395.3 272.065Z",
    fill: "#FFD0F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M506.558 272.065H395.3L450.929 327.695L506.558 272.065Z",
    fill: "#FF97F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 383.324L450.929 327.695L395.3 272.065V383.324Z",
    fill: "#FFD0F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 383.324V272.065L339.671 327.695L395.3 383.324Z",
    fill: "#FF97F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.065L284.041 272.065L339.671 327.695L395.3 272.065Z",
    fill: "#FF97F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M284.041 272.065L395.3 272.065L339.671 216.436L284.041 272.065Z",
    fill: "#FFD0F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.065V160.807L339.671 216.436L395.3 272.065Z",
    fill: "#FF97F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 160.807V272.065L450.929 216.436L395.3 160.807Z",
    fill: "#FFD0F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M398.161 380.667C396.637 382.191 394.167 382.191 392.643 380.667L342.532 330.557C341.008 329.033 341.008 326.562 342.532 325.038L392.643 274.927C394.167 273.403 396.637 273.403 398.161 274.927L448.272 325.038C449.796 326.562 449.796 329.033 448.272 330.557L398.161 380.667Z",
    fill: "#C4C4C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 272.168L395.402 383.426L451.032 327.797L395.402 272.168Z",
    fill: "#FFD0F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 383.426L395.402 272.168L339.773 327.797L395.402 383.426Z",
    fill: "#FF97F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M284.144 272.168L339.773 327.797L395.402 272.168L284.144 272.168Z",
    fill: "#FFD0F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.144 272.168L395.402 272.168L339.773 216.538L284.144 272.168Z",
    fill: "#FF97F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 272.168V160.909L339.773 216.538L395.402 272.168Z",
    fill: "#FF97F1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 160.909V272.168L451.032 216.538L395.402 160.909Z",
    fill: "#FFD0F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 272.168L506.661 272.168L451.032 216.538L395.402 272.168Z",
    fill: "#FF97F1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M506.661 272.168L395.402 272.168L451.032 327.797L506.661 272.168Z",
    fill: "#FFD0F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M286.8 275.03C285.276 273.506 285.276 271.036 286.8 269.512L336.911 219.401C338.435 217.877 340.906 217.877 342.43 219.401L392.54 269.512C394.064 271.036 394.064 273.506 392.54 275.03L342.43 325.141C340.906 326.665 338.435 326.665 336.911 325.141L286.8 275.03Z",
    fill: "#C4C4C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.271L284.041 272.271L339.671 327.9L395.3 272.271Z",
    fill: "#FFD0F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M284.041 272.271L395.3 272.271L339.671 216.642L284.041 272.271Z",
    fill: "#FF97F1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 161.012L339.671 216.642L395.3 272.271V161.012Z",
    fill: "#FFD0F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 161.012V272.271L450.929 216.642L395.3 161.012Z",
    fill: "#FF97F1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.271L506.559 272.271L450.929 216.642L395.3 272.271Z",
    fill: "#FF97F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M506.559 272.271L395.3 272.271L450.929 327.9L506.559 272.271Z",
    fill: "#FFD0F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 272.271L395.3 383.53L450.929 327.9L395.3 272.271Z",
    fill: "#FF97F1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M395.3 383.53L395.3 272.271L339.671 327.9L395.3 383.53Z",
    fill: "#FFD0F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M488.955 272.168C488.955 323.893 447.024 365.824 395.299 365.824C343.574 365.824 301.642 323.893 301.642 272.168C301.642 220.443 343.574 178.511 395.299 178.511C447.024 178.511 488.955 220.443 488.955 272.168Z",
    fill: "url(#paint14_linear_7088_4236)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M485.053 272.169C485.053 321.738 444.869 361.923 395.299 361.923C345.729 361.923 305.545 321.738 305.545 272.169C305.545 222.599 345.729 182.415 395.299 182.415C444.869 182.415 485.053 222.599 485.053 272.169Z",
    fill: "url(#paint15_linear_7088_4236)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M471.395 272.168C471.395 314.194 437.325 348.264 395.299 348.264C353.272 348.264 319.203 314.194 319.203 272.168C319.203 230.141 353.272 196.072 395.299 196.072C437.325 196.072 471.395 230.141 471.395 272.168Z",
    fill: "url(#paint16_linear_7088_4236)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M467.492 272.169C467.492 312.04 435.17 344.362 395.298 344.362C355.427 344.362 323.105 312.04 323.105 272.169C323.105 232.297 355.427 199.975 395.298 199.975C435.17 199.975 467.492 232.297 467.492 272.169Z",
    fill: "url(#paint17_radial_7088_4236)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M467.492 272.169C467.492 312.04 435.17 344.362 395.298 344.362C355.427 344.362 323.105 312.04 323.105 272.169C323.105 232.297 355.427 199.975 395.298 199.975C435.17 199.975 467.492 232.297 467.492 272.169Z",
    fill: "url(#paint18_radial_7088_4236)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M394.146 225.749C394.697 224.932 395.899 224.932 396.451 225.749L427.279 271.392C427.596 271.862 427.596 272.478 427.279 272.949L396.451 318.592C395.899 319.408 394.697 319.408 394.146 318.592L363.318 272.949C363 272.478 363 271.862 363.318 271.392L394.146 225.749Z",
    fill: "#7B33D1",
    fillOpacity: 0.49
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 232.064L368.528 272.17H383.825L395.297 254.122V232.064Z",
    fill: "url(#paint19_linear_7088_4236)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M422.067 272.17L395.297 232.064V254.122L406.77 272.17H422.067Z",
    fill: "url(#paint20_linear_7088_4236)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 312.277L422.067 272.17H406.77L395.297 290.218V312.277Z",
    fill: "url(#paint21_linear_7088_4236)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M368.528 272.17L395.297 312.277V290.218L383.825 272.17H368.528Z",
    fill: "url(#paint22_linear_7088_4236)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M406.77 272.17L395.297 254.122L383.825 272.17L395.297 290.218L406.77 272.17Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 404.609,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint23_radial_7088_4236)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 404.61,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint24_radial_7088_4236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7088_4236",
    x1: 395.003,
    y1: 39.2695,
    x2: 395.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7088_4236",
    x1: 395.003,
    y1: 484.596,
    x2: 395.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7088_4236",
    x1: 655.591,
    y1: 261.94,
    x2: 387.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7088_4236",
    x1: 108.131,
    y1: 261.94,
    x2: 402.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7088_4236",
    x1: 524.546,
    y1: 488.906,
    x2: 390.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7088_4236",
    x1: 234.467,
    y1: 14.8011,
    x2: 381.468,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7088_4236",
    x1: 620.478,
    y1: 392.976,
    x2: 388.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7088_4236",
    x1: 130.013,
    y1: 119.262,
    x2: 384.628,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7088_4236",
    x1: 262.456,
    y1: 488.909,
    x2: 396.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7088_4236",
    x1: 551.656,
    y1: 14.7982,
    x2: 404.655,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7088_4236",
    x1: 166.525,
    y1: 392.975,
    x2: 398.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7088_4236",
    x1: 656.107,
    y1: 119.263,
    x2: 401.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(394.111 306.958) rotate(90) scale(146.152 340.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC78FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC78FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(394.111 306.958) rotate(90) scale(146.152 340.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC78FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC78FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7088_4236",
    x1: 394.111,
    y1: 160.807,
    x2: 394.111,
    y2: 453.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7002"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7088_4236",
    x1: 394.111,
    y1: 160.807,
    x2: 394.111,
    y2: 453.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7088_4236",
    x1: 394.111,
    y1: 160.807,
    x2: 394.111,
    y2: 453.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD446"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.803 237.953) rotate(30.1577) scale(352.458 407.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E31E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.757 225.042) rotate(28.2423) scale(58.4676 100.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7088_4236",
    x1: 172.323,
    y1: 253.47,
    x2: 198.33,
    y2: 319.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7088_4236",
    x1: 465.304,
    y1: 260.119,
    x2: 546.413,
    y2: 145.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7088_4236",
    x1: 440.889,
    y1: 339.904,
    x2: 451.442,
    y2: 402.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF88EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E962D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7088_4236",
    x1: 310.675,
    y1: 326.607,
    x2: 311.279,
    y2: 406.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 404.609) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC78FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC78FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_7088_4236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 404.61) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC78FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC78FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10Badge);
export default __webpack_public_path__ + "static/media/Level10Badge.d178af3dd38f062ad182b7fcfd9ec2f4.svg";
export { ForwardRef as ReactComponent };